import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CarouselModule } from 'primeng/carousel';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { SelectModule } from 'primeng/select';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { ImageModule } from 'primeng/image';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [],
  imports: [
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    TranslateModule.forRoot(),
    TooltipModule,
    SkeletonModule,
    CarouselModule,
    DividerModule,
    MenuModule,
    DialogModule,
    DynamicDialogModule,
    SelectModule,
    MultiSelectModule,
    DragDropModule,
    OrderListModule,
    ImageModule,
    ToggleSwitchModule,
    PanelModule,
    ProgressBarModule,
    InputNumberModule,
    InputGroupModule,
    InputGroupAddonModule,
  ],
  exports: [
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    TranslateModule,
    TooltipModule,
    SkeletonModule,
    CarouselModule,
    DividerModule,
    MenuModule,
    DialogModule,
    DynamicDialogModule,
    SelectModule,
    MultiSelectModule,
    DragDropModule,
    OrderListModule,
    ImageModule,
    ToggleSwitchModule,
    PanelModule,
    ProgressBarModule,
    InputNumberModule,
    InputGroupModule,
    InputGroupAddonModule,
  ],
  providers: [],
  bootstrap: [],
})
export class PrimeNgModule {}
